module.exports = __webpack_public_path__ + "static/media/nav-logo.3c711768.png";